export const badgeConfig = {
  // Streak Rozetleri
  streakBeginner: {
    type: "goal",
    threshold: 3,
    name: "Kıvılcım",
    description: "Serüven başlıyor. (3 günlük çalışma serisi yap)",
    icon: "🔥",
  },
  streakStar: {
    type: "goal",
    threshold: 7,
    name: "İstikrar Yıldızı",
    description: "Disiplin yavaş yavaş oturuyor. (7 günlük çalışma serisi yap)",
    icon: "⭐",
  },
  streakWarrior: {
    type: "goal",
    threshold: 15,
    name: "Demir İrade",
    description: "Pes etmek senin lügatinde yok. (15 günlük çalışma serisi yap)",
    icon: "⚔️",
  },
  streakLegend: {
    type: "goal",
    threshold: 30,
    name: "Efsanevi Öğrenci",
    description: "Sen artık bir efsanesin! (30 günlük çalışma serisi yap)",
    icon: "👑",
  },
  // Plan ve Görev Rozetleri
  planMaster: {
    type: "plan",
    threshold: 5,
    name: "Plan Ustası",
    description: "Zamanını iyi yönetiyorsun. (5 günlük planı tamamen bitir)",
    icon: "📋",
  },
  taskTerminator: {
    type: "plan",
    threshold: 50,
    name: "Görev Avcısı",
    description: "Listeleri yok eden makine. (Toplam 50 görev tamamla)",
    icon: "🎯",
  },
  // Sosyal ve Sistem Rozetleri
  socialButterfly: {
    type: "social",
    threshold: 1,
    name: "Sosyal Kelebek",
    description: "Topluluğa karıştın. (Foruma ilk mesajını gönder)",
    icon: "🦋",
  },
  premiumMember: {
    type: "system",
    threshold: 0,
    name: "Elit Üye",
    description: "Platformun ayrıcalıklı özelliklerini keşfediyor. (Premium üyeliğe geç)",
    icon: "💎",
  },
  earlyAdopter: {
    type: "system",
    threshold: 0,
    name: "Öncü Birlik",
    description: "Yelken'e ilk katılan efsanevi oyunculardan biri. (Kapalı beta döneminde kayıt ol)",
    icon: "🚀",
  }
};